import React from 'react';
import css from './FilterPanel.module.css';
import { RxCross1 } from 'react-icons/rx';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const FilterPanel = props => {
  const {
    validQueryParams = {},
    handleRemoveOneFilter,
    availableFilters = [],
    resetAll,
    allowCategoryRemoval = false,
  } = props;
  const history = useHistory();
  const location = history.location;
  const pathname = location?.pathname;
  const showAll = pathname.includes('all_products');
  const isMegaMenuOpen = !showAll && !allowCategoryRemoval;
  const isFromSearch =
    validQueryParams?.fromSearch === true || validQueryParams?.fromSearch === 'true';
  const isSearchBarSearch = !!validQueryParams?.keywords || isFromSearch;
  function formatPriceRange(priceRange) {
    const [minPrice, maxPrice] = priceRange.split(','); // Split the string by comma
    const euroSign = '€';
    return `${minPrice}${euroSign} - ${maxPrice}${euroSign}`;
  }
  const findFilter = key =>
    availableFilters.find(filter => filter?.key === key.replace(/^(pub_|meta_)/, ''));
  // URL parameters also contain tracking and UI state. Only configured filters
  // should become chips; arbitrary values such as fbclid can overflow the layout.
  const selectFilterKeys = Object.keys(validQueryParams || {}).filter(key => findFilter(key));

  const intl = useIntl();
  const priceFilter = validQueryParams?.price;
  const getOptionLabel = (filter, value) => {
    const options = filter?.enumOptions || filter?.options || [];
    const option = options.find(option => {
      const optionValue = option.value || option.key || option.option;
      return `${optionValue}` === `${value}`;
    });
    return option?.labelTranslationKey
      ? intl.formatMessage({ id: option.labelTranslationKey })
      : option?.label || value;
  };

  const removeFilters =
    isMegaMenuOpen && !isSearchBarSearch
      ? selectFilterKeys
          .filter(i => i != 'pub_department')
          .filter(i => i != 'showFilters')
          .filter(i => i != 'pub_category')
          .filter(i => i != 'fromSearch')
          .filter(k => k !== 'keywords')
          .filter(k => k !== 'price')
          .filter(k => k !== 'sort')
          .filter(k => k !== 'mega')
      : selectFilterKeys
          .filter(i => i != 'pub_department')
          .filter(i => i != 'showFilters')
          .filter(i => i != 'fromSearch')
          .filter(k => k !== 'keywords')
          .filter(k => k !== 'price')
          .filter(k => k !== 'sort')
          .filter(k => k !== 'mega');
  const hasVisibleFilters = !!priceFilter || removeFilters?.length > 0;

  return hasVisibleFilters ? (
    <div className={css.filterContainer}>
      {priceFilter ? (
        <div className={css.filterValues}>
          <div className={css.filterValue}>{formatPriceRange(priceFilter)}</div>
          <div
            className={css.delete}
            onClick={() => {
              handleRemoveOneFilter('price', priceFilter);
            }}
          >
            <RxCross1 className={css.deleteIcon} />
          </div>
        </div>
      ) : null}
      {removeFilters.map((key, index) => {
        const validFilter = findFilter(key);

        const values = validQueryParams[key];

        const multiValue =
          typeof values === 'string'
            ? values.split(',')
            : typeof values === 'number'
            ? values.toString().split(',')
            : [];

        return (
          <div key={key} className={css.filter}>
            {multiValue?.length > 1 ? (
              multiValue?.map((value, index) => {
                return (
                  <div className={css.filterValues}>
                    <div key={index + key} className={css.filterValue}>
                      {getOptionLabel(validFilter, value)}
                    </div>

                    <div
                      key={values}
                      className={css.delete}
                      onClick={() => {
                        handleRemoveOneFilter(key, value);
                      }}
                    >
                      <RxCross1 className={css.deleteIcon} />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={css.filterValues}>
                <div key={index + key} className={css.filterValue}>
                  {getOptionLabel(validFilter, values)}
                </div>

                <div
                  key={values}
                  className={css.delete}
                  onClick={() => {
                    handleRemoveOneFilter(key, values);
                  }}
                >
                  <RxCross1 className={css.deleteIcon} />
                </div>
              </div>
            )}
          </div>
        );
      })}
      {removeFilters?.length ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          {intl.formatMessage({ id: 'FilterPanel.FilterPanel.clear' })}
        </button>
      ) : null}
    </div>
  ) : null;
};

export default FilterPanel;
